<template>
  <div>
    <ModelSelectPage />
  </div>
</template>

<script>
import ModelSelectPage from '@/components/model-select-page/ModelSelectPage.vue';

export default {
  components: {
    ModelSelectPage
  },
}
</script>